import React from "react";
import styled from "styled-components";
import HeaderSection, {BreadCrumbItem} from './HeaderSection';
import Layout from "../Layout";

export interface ContentSectionProps {
    title: string;
    description: string;
    breadCrumbs: BreadCrumbItem[]
    children?: React.ReactNode;
}

function Page({title, description, breadCrumbs, children}: ContentSectionProps) {
    return (
        <Layout>
            <StyledContent className="main-content container-fluid">
                <HeaderSection title={title} description={description} breadCrumbs={breadCrumbs}/>
                {children}
            </StyledContent>
        </Layout>
    );
}

const StyledContent = styled("div")`
  padding: 10px 20px 0px 20px;
  position: relative;
  width: 100%;
`
export default Page;